import { render, staticRenderFns } from "./reactivo_unico.vue?vue&type=template&id=3a8ca24e&scoped=true&"
import script from "./reactivo_unico.vue?vue&type=script&lang=js&"
export * from "./reactivo_unico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ca24e",
  null
  
)

export default component.exports